import { useEffect, useState } from 'react';
import { Save, X } from 'lucide-react';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import BtnSpinner from '../../components/BtnSpinner';
import { useParams } from 'react-router-dom';

function AddOrEditCourse({ close, setRefresh, lesson }) {

    // console.log(course, 'course')

    const token = localStorage.getItem("token");

    const { course_id, chapter_id } = useParams();

    const [data, setData] = useState({
        lessonId: "",
        title: "",
        file: "",
        description: "",
        status: "",
        lessonImage: "",
        access_type: "",
        fileType: ""
    });

    const [isEdit, setIsEdit] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [loading, setLoading] = useState({ state: false, name: "" });

    // For demo purposes - simulating edit mode with sample data


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({
            ...prev,
            [name]: value
        }));

        // Update preview image when image URL changes
        if (name === 'lessonImage') {
            setPreviewImage(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // console.log(data,'data')

        if (lesson) {
            await handleEditLesson(lesson?.lessonId)
        } else {
            await handleAddLesson();
        }
    };

    const handleAddLesson = async () => {
        setLoading({ state: true, name: "addlesson" });
        try {
            const res = await Apirequests("lesson/create-lesson", "POST", data, {
                Authorization: `Bearer ${token}`,
                chapter_id:chapter_id,
                course_id:course_id
            });
            // console.log(res,'addlessonres');
            if (res?.success) {
                SuccessTost(res?.message);
                close();
                setRefresh((prev) => !prev)
            }else{
                ErrorTost(res?.message)
            }
        } catch (error) {
            console.log(error, 'create course error');
            ErrorTost("Something went wrong, please try again later.")
        }
        setLoading({ state: false, name: "" })
    }

    const handleEditLesson = async (id) => {
        setLoading({ state: true, name: "editlesson" });
        try {
            const res = await Apirequests(`lesson/edit-lesson/${id}`, 'PUT', data, {
                Authorization: `Bearer ${token}`
            });
            // console.log(res,'res')
            if (res?.success) {
                SuccessTost(res?.message);
                close();
                setRefresh((prev) => !prev)
            }
        } catch (error) {
            console.log(error, 'create course error');
            ErrorTost("Something went wrong, please try again later.")
        }
        setLoading({ state: false, name: "" })
    }

    const handleReset = () => {
        setData({
            lessonId: "",
            title: "",
            file: "",
            description: "",
            status: "",
            lessonImage: "",
            access_type: "",
            fileType: ""
        });
        setPreviewImage("");
        setIsEdit(false);
    };

    useEffect(() => {

        // console.log(lesson,'lesson')

        if (lesson) {
            setData({
                lessonId: lesson?.lessonId,
                title: lesson?.title,
                file: lesson?.file,
                description: lesson?.description,
                status: lesson?.status,
                lessonImage: lesson?.lessonImage,
                access_type: lesson?.access_type,
                fileType: lesson?.fileType
            });
            setPreviewImage(lesson?.lessonImage)
            setIsEdit(true)
        }

        return () => {
            setData({
                lessonId: "",
                title: "",
                file: "",
                description: "",
                status: "",
                lessonImage: "",
                access_type: "",
                fileType: ""
            })
            setIsEdit(false);
            setPreviewImage(null)
        }
    }, [lesson])

    return (
        <div className="py-2 px-2 sm:px-2 lg:px-2">
            <div>
                {/* Header */}
                <div className="flex justify-between items-center mb-2">
                    <h1 className="text-3xl font-bold text-gray-900">
                        {isEdit ? 'Edit Lesson' : 'Add New Lesson'}
                    </h1>
                    <div className="flex gap-4">
                        {/* <button
              onClick={loadEditData}
              className="px-4 py-2 text-sm font-medium text-blue-600 hover:text-blue-700"
            >
              Demo: Load Edit Data
            </button> */}
                        {!isEdit && <button
                            onClick={handleReset}
                            className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-700"
                        >
                            Reset Form
                        </button>}
                    </div>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="bg-white rounded-2xl">
                    {/* Image Preview */}
                    <div className="mb-8">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Lesson Image Preview
                        </label>
                        <div className="relative h-72 w-full bg-gray-100 rounded-lg overflow-hidden">
                            {previewImage ? (
                                <img
                                    src={previewImage}
                                    alt="Lesson preview"
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <div className="flex items-center justify-center h-full text-gray-400">
                                    No image preview available
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Basic Information */}
                    <div>
                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Lesson Title *
                            </label>
                            <input
                                type="text"
                                name="title"
                                value={data.title}
                                onChange={handleInputChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter lesson title"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Image URL *
                            </label>
                            <input
                                type="url"
                                name="lessonImage"
                                value={data.lessonImage}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter image URL"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Lesson ID
                            </label>
                            <input
                                type="text"
                                name="lessonId"
                                value={data.lessonId}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter Lesson ID"
                            />
                        </div>

                        {/* <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Internal ID
                            </label>
                            <input
                                type="text"
                                name="internalId"
                                value={course.internalId}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter internal ID"
                            />
                        </div> */}
                    </div>

                    {/* Course Details */}
                    <div>
                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                File *
                            </label>
                            <input
                                type="text"
                                name="file"
                                value={data.file}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter file url"
                            />
                        </div>

                        {/* <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Image
                            </label>
                            <input
                                type="number"
                                name="lessonImage"
                                value={data?.lessonImage}
                                onChange={handleInputChange}
                                min="0"
                                max="100"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter discount"
                            />
                        </div> */}

                        {/* <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Rating
                            </label>
                            <input
                                type="tel"
                                name="course_rating"
                                value={data.course_rating}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter rating"
                            />
                        </div> */}

                        {/* <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Total Lessons *
                            </label>
                            <input
                                type="tel"
                                name="total_lesson"
                                value={data.total_lesson}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter total lessons"
                            />
                        </div> */}

                        {/* <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Total Chapters *
                            </label>
                            <input
                                type="tel"
                                name="total_chapters"
                                value={data.total_chapters}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter total chapters"
                            />
                        </div> */}

                        {/* <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Precedence Level *
                            </label>
                            <input
                                type="tel"
                                name="course_precedance"
                                value={data.course_precedance}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter total chapters"
                            />
                        </div> */}

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                File type *
                            </label>
                            <select
                                name="fileType"
                                value={data.fileType}
                                onChange={handleInputChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="">Please select the file type</option>
                                <option value="image">Image</option>
                                <option value="video">Video</option>
                                <option value="audio">Audio</option>
                                <option value="others">Others</option>
                            </select>
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Acess Type *
                            </label>
                            <select
                                name="access_type"
                                value={data.access_type}
                                onChange={handleInputChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            >
                                 <option value="">Please select access type</option>
                                <option value="Paid">Paid</option>
                                <option value="Free">Free</option>
                            </select>
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Status *
                            </label>
                            <select
                                name="status"
                                value={data.status}
                                onChange={handleInputChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="">Please select the lesson status</option>
                                <option value="Active">Active</option>
                                <option value="Disabled">Disabled</option>
                            </select>
                        </div>
                    </div>

                    {/* Description */}
                    <div className="mb-8">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Description *
                        </label>
                        <textarea
                            name="description"
                            value={data.description}
                            onChange={handleInputChange}
                            rows="4"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter course description"
                        />
                    </div>

                    {/* Form Actions */}
                    <div className="flex gap-4">
                        {isEdit ? <button
                            type="submit"
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                        >
                            {
                                loading.state && loading.name === "editcourse" ?
                                    <BtnSpinner /> :
                                    <>
                                        <Save className="w-5 h-5" />
                                        <span className='text-white'>Update Course</span>
                                    </>
                            }

                        </button>
                            :
                            <button
                                type="submit"
                                className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                            >
                                {
                                    loading.state && loading.name === "addcourse" ?
                                        <BtnSpinner /> :
                                        <>
                                            <Save className="w-5 h-5" />
                                            <span className='text-white'>Create Course</span>
                                        </>
                                }

                            </button>}
                        <button
                            type="button"
                            onClick={() => close()}
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
                        >
                            <X className="w-5 h-5" />
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddOrEditCourse;